export default __webpack_public_path__ + "locales/es/Files.json?hash=15f0740e25392e949b33a7ab50fef586";